import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-4 col-lg-4 col-xxxl-4 col-sm-2" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-sun-horizon" })
], -1)
const _hoisted_7 = { class: "title style-customized-cards-dashboard" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " AM ", -1)
const _hoisted_9 = { class: "fw-black mb-8 lh-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-dark-emphasis" }, " 00:00 - 12:00 ", -1)
const _hoisted_11 = { class: "col-xl-2 col-lg-4 col-xxxl-4 col-sm-2" }
const _hoisted_12 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_13 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_14 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-calendar-blank" })
], -1)
const _hoisted_16 = { class: "title style-customized-cards-dashboard" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Tamanho total ", -1)
const _hoisted_18 = { class: "fw-black mb-8 lh-1" }
const _hoisted_19 = { class: "col-xl-2 col-lg-4 col-xxxl-4 col-sm-2" }
const _hoisted_20 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_21 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_22 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-file-audio" })
], -1)
const _hoisted_24 = { class: "title style-customized-cards-dashboard" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Tamanho médio de arquivo ", -1)
const _hoisted_26 = { class: "fw-black mb-8 lh-1" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-xl-4 col-lg-4 col-xxxl-4 col-sm-2" }
const _hoisted_29 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_30 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_31 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-cloud-moon" })
], -1)
const _hoisted_33 = { class: "title style-customized-cards-dashboard" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " PM ", -1)
const _hoisted_35 = { class: "fw-black mb-8 lh-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-dark-emphasis" }, " 12:01 - 23:59 ", -1)
const _hoisted_37 = { class: "col-xl-2 col-lg-4 col-xxxl-4 col-sm-2" }
const _hoisted_38 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_39 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_40 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-soundcloud-logo" })
], -1)
const _hoisted_42 = { class: "title style-customized-cards-dashboard" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Tempo total de gravação ", -1)
const _hoisted_44 = { class: "fw-black mb-8 lh-1" }
const _hoisted_45 = { class: "col-xl-4 col-lg-4 col-xxxl-4 col-sm-2" }
const _hoisted_46 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_47 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_48 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-cassette-tape" })
], -1)
const _hoisted_50 = { class: "title style-customized-cards-dashboard" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Tempo médio de gravação ", -1)
const _hoisted_52 = { class: "fw-black mb-8 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.getDashboardMonthCards.am), 1),
                _hoisted_10
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("h4", _hoisted_18, _toDisplayString((_ctx.getDashboardMonthCards.total_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("h4", _hoisted_26, _toDisplayString((_ctx.getDashboardMonthCards.average_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.getDashboardMonthCards.pm), 1),
                _hoisted_36
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.convertTime(_ctx.getDashboardMonthCards.total_time)), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("h4", _hoisted_52, _toDisplayString(_ctx.convertTime(_ctx.getDashboardMonthCards.average_time)), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}